import { CardTabDeprecated, CardTabsDeprecated, Title } from 'ui';

const DuplicateInviteesSection = ({ eventId }: { eventId?: string }) => (
  <>
    <Title level={4} marginBottom>
      Invitees
    </Title>
    <Title level={5} marginBottom>
      Do you want to duplicate event with all invitees?
    </Title>
    <CardTabsDeprecated
      name="duplicateInviteesFromEvent"
      tabs={[
        {
          content: (
            <CardTabDeprecated subtitle="All current invitees will get invitations for this event" title="Yes" />
          ),
          id: 'include-invitees',
          key: eventId,
        },
        {
          content: (
            <CardTabDeprecated
              subtitle="There will be no attendees for this event, once this event is duplicated"
              title="No"
            />
          ),
          id: 'exclude-invitees',
          key: undefined,
        },
      ]}
    />
  </>
);

export default DuplicateInviteesSection;
